// Declared here too (guarded), so this script works whichever theme script arrives first.
if (typeof debounce === 'undefined') {
  var debounce = function(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');
      const notesEl = document.getElementById('mini-cart__notes');
      const request = fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(notesEl ? { note: notesEl.value } : {})
      });

      // shopify:cart:lines-update — /cart/clear.js responds with the emptied cart
      const SE = window.Shopify && window.Shopify.StandardEvents;
      if (SE) {
        publishStandardEvent('CartLinesUpdateEvent', {
          action: 'remove',
          promise: request
            .then((response) => response.json())
            .then((cart) => ({ cart: cart && cart.token ? SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : null }))
        }, this);
      }

      request.then(() => {
        this.classList.remove('loading');
        this.drawer.refresh();
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}